<template>
	<div style="display:none;">
		<div :id="qrid">
			<div class="qr-row">
				<qrcode-vue style="width:200px;height:200px;" :value="code"  level="H" />
			</div>
		</div>
	</div>
</template>

<script setup>
import {toRefs, defineExpose, ref, nextTick } from 'vue'
import QrcodeVue from 'qrcode.vue'
import printjs from 'print-js'

const props = defineProps({
	code:{
		type:String,
		default:'info'
	}
})
const {code} = toRefs(props)

const show = function(){
	nextTick(()=>{
		printjs({
			printable: qrid.value,
			type: 'html',
			scanStyles: false,
			style:'.qr-row{display:flex;justify-content: center;}'
		})
	})
}

const qrid = ref('qr-print-0')

qrid.value = 'qr-print-' + new Date().getTime()

defineExpose({show})
</script>

<style>

</style>